module.exports = __webpack_public_path__ + "img/hotel_staff_face_icon.0c25b5f1.png";